// Card 09, depth tints (R2616, R2713, R2726; ui-map-interface.md §17.3.09,
// v2-the-deep.md §13; mockup round 088 card 04 and round 116 cards 01,
// 02, 05 and 09).
//
// A chart paints its water in blues by depth: the deeper the band, the
// darker the sea. The picture is per-pixel, so it is ONE full-world quad of
// the depth layer (`fast/layers/depth.ts`), and the piece draws no batch.
// It hands the band field and the reading to the layer through the scene,
// as card 01 hands its lines to the terrain program. The depth look (the
// feathered tints, or the tint steps alone) is the World field `depth`,
// which the key `\` flips for the session (`depthlook.ts`, R2726). The
// shoal stipple and the edge seam are the pieces of cards 71 and 72
// (`depth-marks.ts`).
// No look draws a rule on a band edge (round 116 brief).
//
// **IT DRAWS WHAT THE WIRE SENDS.** The band field is `Hello.depth`
// (R2609), nil while the flag `depth` is off, so a world with the flag off
// draws nothing. A cell with no band (rock, or water the survey does not
// hold) takes no tint. The piece reads no flag (§14.1 rule 5).
//
// **THE GATE IS THE SCENE'S.** The controller never calls a piece the
// gate has dropped, so `MapScene.setVisibility` hands the gate of this
// piece to the layer on every frame, and the layer keeps the field while
// the piece is hidden.

import type { ChartContext, ChartSinks, Piece } from '../context';

export class DepthTintsPiece implements Piece {
  readonly id = 'depth_tints' as const;
  readonly tier = 'sea' as const;
  readonly pack = 'static' as const;
  /** The sea the fight happened in. It stays under a replay film. */
  readonly film = 'keep' as const;
  /** A survey grows the band field in place, so it hands it over again. */
  readonly rebuildOn = ['hello', 'reading', 'survey'] as const;

  visible(ctx: ChartContext): boolean {
    return ctx.state.depthBands !== null;
  }

  /** Writes the band field and the reading into the depth layer. */
  rebuild(ctx: ChartContext): void {
    ctx.scene.setDepthField?.(ctx.reading, ctx.state.depthBands);
  }

  /** Nothing. The picture is the depth layer's quad. */
  emit(_sinks: ChartSinks, _ctx: ChartContext): void {
    // The tints are per-pixel. There is no instance to write.
  }
}

/** The one instance the registry holds, and the scene asks about. */
export const depthTints = new DepthTintsPiece();
